import { render } from "./TrianglesConstructeurs.vue?vue&type=template&id=6e07a349&scoped=true"
import script from "./TrianglesConstructeurs.vue?vue&type=script&lang=js"
export * from "./TrianglesConstructeurs.vue?vue&type=script&lang=js"

import "./TrianglesConstructeurs.vue?vue&type=style&index=0&id=6e07a349&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e07a349"]])

export default __exports__